import { combineReducers } from 'redux';
import actionTypes from './actionTypes';
import { REDUCER_NAME } from './constants';

import { REDUCER_NAME as VIEW_REDUCER_NAME } from './View/constants';
import viewReducer from './View/reducer';

import { REDUCER_NAME as MASTER_WAYBILLS_REDUCER_NAME } from './MasterWaybills/constants';
import masterWaybillsReducer from './MasterWaybills/reducer';

const initialState = {
  data: [],
  isFetching: true,
  nextCursor: null,
  prevCursor: null,
  cache: {},
  cursor: null,
};

const reducer = function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isFetching: true,
        data: [],
      };

    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
        data: action.payload.append ? state.data : [],
      };

    case actionTypes.FETCHED:
      return {
        ...state,
        isFetching: false,
        data: action.meta.append ? [...state.data, ...action.payload.data] : action.payload.data,
        nextCursor: action.meta.nextCursor ? action.meta.nextCursor : null,
        prevCursor: action.meta.prevCursor ? action.meta.prevCursor : null,
        cursor: action.meta.cursor,
        filters: action?.meta?.filters || {},
      };

    case actionTypes.CACHE:
      return {
        ...state,
        cache: {
          ...state.cache,
          [action.payload.key]: {
            ...(state.cache[action.payload.key] ? state.cache[action.payload.key] : {}),
            ...action.payload.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: reducer,
  [VIEW_REDUCER_NAME]: viewReducer,
  [MASTER_WAYBILLS_REDUCER_NAME]: masterWaybillsReducer,
});
